import { Badge, Box, Typography } from "@mui/material";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import { useTranslation } from "react-i18next";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { useUserAssistance } from "./UserAssistanceContext";

export default function AskAnythingButton({
  compact = false,
}: {
  compact?: boolean;
}) {
  const { t } = useTranslation();
  const { toggle, unreadCount } = useUserAssistance();

  return (
    <Badge
      color="error"
      variant="dot"
      invisible={!unreadCount}
      overlap="rectangular"
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      sx={{
        "& .MuiBadge-badge": {
          width: 10,
          height: 10,
          minWidth: 10,
          borderRadius: "50%",
          top: 3,
          right: -1,
          transform: "scale(1) translate(50%, -50%)",
        },
      }}
    >
    <Box
      component="button"
      type="button"
      data-ask-anything-trigger="true"
      onClick={(event) => {
        event.stopPropagation();
        toggle(event.currentTarget);
      }}
      aria-label={t("Ask Max")}
      sx={{
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        border: "none",
        padding: compact ? "2px" : "3px",
        borderRadius: "999px",
        cursor: "pointer",
        background: "transparent",
        overflow: "hidden",
        appearance: "none",
        font: "inherit",
        boxShadow: compact ? 2 : 6,
        "@keyframes assistanceBorderSpin": {
          from: { transform: "rotate(0deg)" },
          to: { transform: "rotate(360deg)" },
        },
        "&:hover .assistance-fab-inner": {
          filter: "brightness(1.08)",
        },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          width: 220,
          height: 220,
          transform: "translate(-50%, -50%)",
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "100%",
            background:
              "conic-gradient(#ff4d6d, #ff9f1c, #ffd166, #06d6a0, #4cc9f0, #7b2cbf, #ff4d6d)",
            animation: "assistanceBorderSpin 3s linear infinite",
          }}
        />
      </Box>
      <Box
        className="assistance-fab-inner"
        sx={{
          position: "relative",
          zIndex: 1,
          display: "flex",
          alignItems: "center",
          gap: compact ? 0.75 : 1,
          px: compact ? 1.25 : 1.75,
          py: compact ? 0.5 : 0.6,
          borderRadius: "999px",
          bgcolor: "background.paper",
          color: "text.primary",
          transition: "filter 0.2s",
          minHeight: "22px"
        }}
      >
        <AutoFixHighIcon
          sx={{ fontSize: compact ? 18 : 22, color: "warning.main" }}
        />
        {/* <img
          src={`/MaxFull.png`}
          style={{ width: "22px", height: "22px", marginLeft:"-7px",
            backgroundColor: "white", padding: "1px", borderRadius: "50%"
           }}
        /> */}
        <Typography
          component="span"
          sx={{
            fontWeight: 700,
            fontSize: compact ? "0.8rem" : "0.95rem",
            lineHeight: 1,
            whiteSpace: "nowrap",
            pr: 0.25,
          }}
        >
          {t("Ask Max")}
        </Typography>   
        {/* <AutoAwesomeIcon
          sx={{ fontSize: compact ? 18 : 22, color: "orange" }}
        />           */}
      </Box>
    </Box>
    </Badge>
  );
}
